import CategoryInfo from "./CategoryInfo";

export default CategoryInfo;
